import { useEffect, useState } from 'react';
import type { FooterResponse } from '../../pages/api/types';
import { getAnonymously } from '../api';
import SalesforceChat from '../layout/salesforceChat';
import FooterContact from './FooterContact';
import FooterLinks from './FooterLinks';

const initialFooterData: FooterResponse = {
    footerLinks: [],
    address: '',
    contact: {
        phone: '',
        email: '',
    },
    facebook: '',
    linkedIn: '',
    organizationNumber: '',
    title: '',
    openingHours: {
        title: '',
        openingHours: [],
    } as any,
    linkToEnglishPage: undefined,
};

export default function Footer({ data: initialData }: { data?: FooterResponse }) {
    const [data, setData] = useState<FooterResponse>(initialData ?? initialFooterData);

    useEffect(() => {
        if (initialData) return;
        getAnonymously<FooterResponse>('/api/footer').then(setData);
    }, [initialData]);

    return (
        <>
            <SalesforceChat />
            <FooterLinks footerLinks={data.footerLinks} />
            <FooterContact {...data} />
        </>
    );
}
